import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { LoggerProvider } from '@opentelemetry/sdk-logs';
import { logs } from '@opentelemetry/api-logs';

import { EMPTY_ATTRIBUTE_SOURCE, type AttributeSource } from '../types/attribute-source';
import type { OtelSignalConfig } from '../types/otel-signal-config';

import { createResource } from './create-resource';
import { EnrichedLogRecordProcessor } from './enriched-log-record-processor';

export interface OtelLoggingConfig extends OtelSignalConfig {
  logExporterUrl: string;
  // Provides app-specific attributes attached to every log record. Defaults to none.
  attributeSource?: AttributeSource;
}

export function initializeOtelLogging({
  serviceName,
  environment,
  logExporterUrl,
  attributeSource = EMPTY_ATTRIBUTE_SOURCE,
}: OtelLoggingConfig): void {
  const resource = createResource({ serviceName, environment });

  const logExporter = new OTLPLogExporter({ url: logExporterUrl });
  const loggerProvider = new LoggerProvider({
    resource,
    processors: [new EnrichedLogRecordProcessor(logExporter, attributeSource)],
  });
  logs.setGlobalLoggerProvider(loggerProvider);
}
